import { gql } from '@graphql/__generated__';

export const INSERT_AND_SET_VISIBILITY_PHONE = gql(/* GraphQL */ `
  mutation InsertAndSetVisibilityPhone(
    $userId: uuid!
    $input: phone_numbers_insert_input!
  ) {
    clear: update_phone_numbers(
      where: { user_id: { _eq: $userId }, is_visibility: { _eq: true } }
      _set: { is_visibility: false }
    ) {
      returning {
        id
        is_visibility
      }
    }
    insert_phone_numbers_one(object: $input) {
      id
      number
      primary
      type
      is_visibility
      user {
        id
        phone_numbers(order_by: [{ primary: desc }, { created_at: desc }]) {
          id
          number
          primary
          type
          is_visibility
        }
      }
    }
  }
`);

export const CLEAR_VISIBILITY_PHONES = gql(/* GraphQL */ `
  mutation ClearVisibilityPhones($userId: uuid!) {
    update_phone_numbers(
      where: { user_id: { _eq: $userId }, is_visibility: { _eq: true } }
      _set: { is_visibility: false }
    ) {
      returning {
        id
        is_visibility
      }
    }
  }
`);

export const SET_VISIBILITY_PHONE = gql(/* GraphQL */ `
  mutation SetVisibilityPhone($userId: uuid!, $phoneId: uuid!) {
    clear: update_phone_numbers(
      where: { user_id: { _eq: $userId }, is_visibility: { _eq: true } }
      _set: { is_visibility: false }
    ) {
      returning {
        id
        is_visibility
      }
    }
    update_phone_numbers_by_pk(
      pk_columns: { id: $phoneId }
      _set: { is_visibility: true }
    ) {
      id
      is_visibility
    }
  }
`);
